import { Pipe, PipeTransform } from '@angular/core';
import { BenefitPlanState } from '@models/configuration/model';

export enum BenefitPlanFriendlyStates {
  UpdatesInProgress = 'Updates In Progress',
  PendingSetup = 'Pending Setup',
  CardsOrdered = 'Cards Ordered',
  Active = 'Active',
  Inactive = 'Inactive',
  Closing = 'Closing',
  Closed = 'Closed',
  ClosedDisbursementOnly = 'Closed Disbursement Only',
}

@Pipe({ name: 'benefitPlanState' })
export class BenefitPlanStatePipe implements PipeTransform {
  public static getFriendlyName(value: string): string {
    switch (value) {
      case BenefitPlanState.PropagatingDateEdits:
      case BenefitPlanState.InitiatePropagatingDateEdits:
        return BenefitPlanFriendlyStates.UpdatesInProgress;
      case BenefitPlanState.Draft:
      case BenefitPlanState.Setup:
      case BenefitPlanState.Initiated:
        return BenefitPlanFriendlyStates.PendingSetup;
      case BenefitPlanState.CardsOrdered:
        return BenefitPlanFriendlyStates.CardsOrdered;
      case BenefitPlanState.Active:
      case BenefitPlanState.GracePeriod:
      case BenefitPlanState.RunOut:
        return BenefitPlanFriendlyStates.Active;
      case BenefitPlanState.Reconciliation:
      case BenefitPlanState.RolloverComplete:
      case BenefitPlanState.RolloverProcessing:
      case BenefitPlanState.RolloverProcessingPreCheck:
      case BenefitPlanState.FinalizationPreCheck:
      case BenefitPlanState.FinalizingAccounts:
      case BenefitPlanState.FinalizingError:
      case BenefitPlanState.FinalizingPlan:
        return BenefitPlanFriendlyStates.Closing;
      case BenefitPlanState.Finalized:
        return BenefitPlanFriendlyStates.Closed;
      case BenefitPlanState.ClosedDisbursementOnly:
        return BenefitPlanFriendlyStates.ClosedDisbursementOnly;
      default:
        return value;
    }
  }

  public transform(value: string, _args?: boolean): string {
    return BenefitPlanStatePipe.getFriendlyName(value);
  }
}
